import React, { Component } from "react";
import { connect } from "react-redux";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
// import StringInput from "../../components/Input/StringInput/StringInput";
import Button from "../../components/Button/Button";
import { formValidation, clearFormValidation, filterErrorHandler } from "../../hoc/Shared/utility";
import Swal from "sweetalert2";
import { withNamespaces } from "react-i18next";
import ValidationError from "../../components/ValidationError/ValidationError";
import NumberInput from '../../components/Input/NumberInput/NumberInput';
import Skeleton from "react-loading-skeleton";
import Select from "../../components/Input/Select/Select";
import * as actions from '../../store/ducks/agentCommission/actions';

class AgentCommissionEdit extends Component 
{
    constructor() 
    {
        super();
        this.state = 
        {
            id: null,
            setting_list: [{listIndex: Math.random(), operation: "", percentage: "", min: "", max: "", min_active: ""}],
            loading: true,
            error_message: [],
            touched: false,
        };
        this.handleSettingListChange = this.handleSettingListChange.bind(this);
        this.addRecord = this.addRecord.bind(this);
        this.removeRecord = this.removeRecord.bind(this);
    }

    componentDidMount() 
    {
        formValidation("agent_commission_form");
        if(this.props.selectId)
        {
            this.props.funcGetDetails(this.props.selectId);
        }
    }

    shouldComponentUpdate(nextProps, nextState) 
    {
        const { t } = this.props;
        if (nextProps.details !== this.props.details && nextProps.details!==undefined)
        {
            if(nextProps.details.responseCode === 200 && nextProps.details.msgType === 'success')
            {
                let data = nextProps.details.data.result;
                let settingValue = JSON.parse(nextProps.details.data.result.data);
                let settingList = [];
                
                Object.keys(settingValue).map((key) => 
                {
                    settingList.push({listIndex: Math.random(), operation: settingValue[key].operation, percentage: settingValue[key].percentage, min: settingValue[key].min, max: settingValue[key].max, min_active: settingValue[key].min_active, invitation_only: !!settingValue[key].invitation_only});
                    return null;
                });
                
                this.setState({
                    id: data.id,
                    setting_list: settingList,
                    loading: false,
                });
            }
            else {
                this.setState({
                    id: null,
                    setting_list: [{listIndex: Math.random(), operation: "", percentage: "", min: "", max: "", min_active: ""}],
                }, () => {
                    filterErrorHandler(nextProps.details.message);
                });
            }
        }

        if (nextProps.update !== this.props.update && nextProps.update!==undefined)
        {
            if(nextProps.update.responseCode === 200 && nextProps.update.msgType === 'success')
            {
                Swal.fire({
                    icon: 'success',
                    title: t('global.success'),
                    html: t('global.record-updated'),
                    showConfirmButton: true
                }).then(() => 
                {
                    clearFormValidation('agent_commission_form');
                    this.props.refreshHandler();
                    this.props.changePageHandler('listing');
                });
            }
            else
            {
                this.setState({
                    touched: true,
                    error_message: nextProps.update.message
                });
                Swal.close();
            }
        }

        return true;
    }

    submitHandler = (e) => 
    {
        e.preventDefault();
        const { t } = this.props;
        Swal.fire({
            title: t("global.confirmation"),
            text: t("global.are-you-sure"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: t("global.update"),
            cancelButtonText: t("global.cancel"),
        }).then((result) => 
        {
            if (result.isConfirmed) 
            {
                Swal.fire({
                    title: "",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    didOpen: () => 
                    {
                        Swal.showLoading();
                    },
                });
                let value_array = [];
                this.state.setting_list.forEach((item) => 
                {
                    value_array.push({operation: item.operation, percentage: item.percentage, min: item.min, max: item.max, min_active: item.min_active, invitation_only: !!item.invitation_only});
                });

                let updateSystemSettingData = {};
                updateSystemSettingData.id = this.state.id;
                updateSystemSettingData.value = value_array;
                this.props.funcUpdate(updateSystemSettingData);
            }
        });
    };

    addRecord = () => 
    {
        if(this.state.setting_list.length < 20) 
        {
            this.setState((prevState) => ({
                setting_list: [...prevState.setting_list, {listIndex: Math.random(), operation: "", percentage: "", min: "", max: "", min_active: ""}],
            }));
        }
    };

    removeRecord = (i) => 
    {
        this.setState({
            setting_list: this.state.setting_list.filter((item, idx) => i !== idx)
        })
    }

    handleSettingListChange = (event, key) => 
    {
        let setting_list = [...this.state.setting_list];
        setting_list[key][event.target.id] = event.target.value;
        // console.log(setting_list);
        this.setState({setting_list});
    }

    render() 
    {
        const { t } = this.props;
        let display = null;
        
        if (!this.state.loading) 
        {
            display = (
                <div className="row row-sm">
                    <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12">
                        <div className="card box-shadow-0">
                            <div className="card-header">
                                <h4 className="card-title mb-1">{t("agent-commission.edit-setting")}</h4>
                            </div>

                            <div className="card-body pt-0">
                                <form method="post" id="agent_commission_form" className="form-horizontal" onSubmit={this.submitHandler} noValidate>
                                    <ValidationError formName="agent_commission_form" touched={this.state.touched} message={this.state.error_message} />

                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className='row'>
                                                <h3 className="card-title col-8">&nbsp;</h3>
                                                <div className="row col-4 justify-content-end mb-2 pr-0">
                                                    <button type="button" className="btn btn-info" onClick={(e) => this.addRecord(e)}>
                                                        <i className="fa fa-plus"></i> {t('agent-commission.add')}
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="table-responsive" style={{overflowY:'auto'}}>
                                                <table className="table" id="setting_table" style={{minWidth:500}}>
                                                    <thead className="text-center bg-primary">
                                                        <tr>
                                                            <th className="text-white p-2">{t("global.no")}</th>
                                                            <th className="text-white p-2">{t("agent-commission.operation")}</th>
                                                            <th className="text-white p-2">{t("agent-commission.percentage")}</th>
                                                            <th className="text-white p-2">{t("agent-commission.min")}</th>
                                                            <th className="text-white p-2">{t("agent-commission.max")}</th>
                                                            <th className="text-white p-2">{t("agent-commission.min-active")}</th>
                                                            <th className="text-white p-2">{t("agent-commission.invitation-only")}</th>
                                                            <th style={{ width: "5%" }}>&nbsp;</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.setting_list.map((item, idx) => 
                                                        {
                                                            return (
                                                                <tr key={idx} className="text-center">
                                                                    <td>{idx + 1}</td>
                                                                    <td key={`operation-${idx}`}>
                                                                        <Select
                                                                            id="operation"
                                                                            name="operation"
                                                                            className="form-control"
                                                                            options={this.props.operationArray}
                                                                            value={item.operation}
                                                                            onChange={(event) => this.handleSettingListChange(event, idx)}
                                                                        />
                                                                    </td>
                                                                    <td key={`percentage-${idx}`}>
                                                                        <NumberInput
                                                                            id='percentage'
                                                                            name='percentage'
                                                                            data-id={idx}
                                                                            placeholder={t("agent-commission.percentage")}
                                                                            value={item.percentage}
                                                                            onKeyPress={(evt) => ((evt.key === 'e' || evt.key === '-' || evt.key === '+') && evt.preventDefault())}
                                                                            onChange={(event) => this.handleSettingListChange(event, idx)}
                                                                            className='form-control'
                                                                            autoComplete="off"
                                                                            required
                                                                        />
                                                                    </td>
                                                                    <td key={`min-${idx}`}>
                                                                        <input
                                                                            id="min"
                                                                            name="min"
                                                                            data-id={idx}
                                                                            className="form-control"
                                                                            placeholder={t("agent-commission.min")}
                                                                            value={item.min}
                                                                            onChange={(event) => this.handleSettingListChange(event, idx)}
                                                                            autoComplete="off"
                                                                            required
                                                                        />
                                                                    </td>
                                                                    <td key={`max-${idx}`}>
                                                                        <NumberInput
                                                                            id='max'
                                                                            name='max'
                                                                            data-id={idx}
                                                                            placeholder={t("agent-commission.max")}
                                                                            value={item.max}
                                                                            onKeyPress={(evt) => ((evt.key === 'e' || evt.key === '-' || evt.key === '+') && evt.preventDefault())}
                                                                            onChange={(event) => this.handleSettingListChange(event, idx)}
                                                                            className='form-control'
                                                                            autoComplete="off"
                                                                            required
                                                                        />
                                                                    </td>
                                                                    <td key={`min-active-${idx}`}>
                                                                        <NumberInput
                                                                            id='min_active'
                                                                            name='min_active'
                                                                            data-id={idx}
                                                                            placeholder={t("agent-commission.min-active")}
                                                                            value={item.min_active}
                                                                            onKeyPress={(evt) => ((evt.key === 'e' || evt.key === '-' || evt.key === '+') && evt.preventDefault())}
                                                                            onChange={(event) => this.handleSettingListChange(event, idx)}
                                                                            className='form-control'
                                                                            autoComplete="off"
                                                                            required
                                                                        />
                                                                    </td>
                                                                    <td key={`invitation-${idx}`}>
                                                                    <input
                                                                        type="checkbox"
                                                                        id="invitation_only"
                                                                        checked={!!item.invitation_only}
                                                                        onChange={(e) => {
                                                                        let setting_list = [...this.state.setting_list];
                                                                        setting_list[idx].invitation_only = e.target.checked;
                                                                        this.setState({ setting_list });
                                                                        }}
                                                                    />
                                                                    </td>

                                                                    <td>
                                                                        <i className="fa fa-trash" style={{color:'red', cursor:'pointer'}} onClick={() => this.removeRecord(idx)}></i>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group mb-0 mt-3 justify-content-end">
                                        <div>
                                            <Button typeButton="submit" classValue="btn btn-blue" idValue="submit" buttonName={t("global.save")} />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        else 
        {
            display = (
                <div className="row row-sm">
                    <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12">
                        <div className="card box-shadow-0">
                            <div className="card-header">
                                <h4 className="card-title mb-1">{t("agent-commission.edit-setting")}</h4>
                            </div>
                            <div className="card-body pt-0">
                                <Skeleton count={4} />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        
        return (
            <Auxiliary>
                <div className="breadcrumb-header">
                    <div className="d-flex">
                        <div className="my-auto">
                            <Button
                                typeButton="button"
                                classValue="btn btn-back-outline"
                                idValue="back"
                                buttonName={<i className="angle fe fe-chevron-left"></i>}
                                clicked={() => this.props.changePageHandler("listing")}
                            />
                        </div>
                    </div>
                    <div className="my-auto">
                        <div className="d-flex">
                            <h4 className="content-title mb-0 my-auto ml-2">{t("side-bar.agent_commission")}</h4>
                        </div>
                    </div>
                </div>
                {display}
            </Auxiliary>
        );
    }
}

const mapStateToProps = (state) => 
{
    return {
        details: state.agentCommission.details,
        update: state.agentCommission.update,
    };
};

const mapDispatchToProps = (dispatch) => 
{
    return {
        funcGetDetails: (id) => dispatch(actions.getDetails(id)),
        funcUpdate: (data) => dispatch(actions.update(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(AgentCommissionEdit));
